import { Link, useLocation } from "react-router";

const Breadcrumb = ({ customBreadcrumbs = null }) => {
    const location = useLocation();
    
    // Default breadcrumb mapping
    const breadcrumbMap = {
        '/': 'Home',
        '/articles': 'Articles',
        '/seminars': 'Seminars',
        '/career-highlights': 'Career Highlights',
        '/qualifications-experience': 'Qualifications & Experience',
        '/gallery': 'Photo Gallery'
    };

    // Generate breadcrumbs from current path
    const generateBreadcrumbs = () => {
        if (customBreadcrumbs) {
            return customBreadcrumbs;
        }

        const pathSegments = location.pathname.split('/').filter(segment => segment);
        const breadcrumbs = [{ path: '/', label: 'Home' }];

        let currentPath = '';
        pathSegments.forEach(segment => {
            currentPath += `/${segment}`;
            const label = breadcrumbMap[currentPath] || segment.charAt(0).toUpperCase() + segment.slice(1);
            breadcrumbs.push({ path: currentPath, label });
        });

        return breadcrumbs;
    };

    const breadcrumbs = generateBreadcrumbs();

    // Don't show breadcrumbs on home page unless there are custom breadcrumbs
    if (location.pathname === '/' && !customBreadcrumbs) {
        return null;
    }

    return (
        <nav 
            className="bg-secondary-50 border-b border-secondary-200 py-3 px-4 sm:px-6 lg:px-8"
            aria-label="Breadcrumb navigation"
        >
            <div className="max-w-7xl mx-auto">
                <ol className="flex items-center space-x-2 text-sm">
                    {breadcrumbs.map((breadcrumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        
                        return (
                            <li key={breadcrumb.path} className="flex items-center">
                                {index > 0 && (
                                    <svg
                                        className="w-4 h-4 text-secondary-400 mx-2"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                )}
                                
                                {isLast ? (
                                    <span 
                                        className="font-medium text-secondary-700"
                                        aria-current="page"
                                    >
                                        {breadcrumb.label}
                                    </span>
                                ) : (
                                    <Link
                                        to={breadcrumb.path}
                                        className="text-secondary-500 hover:text-primary-600 focus:text-primary-600 
                                                 transition-colors duration-200 ease-in-out focus:outline-none 
                                                 focus:ring-2 focus:ring-primary-500 focus:ring-offset-1 rounded-sm px-1"
                                    >
                                        {breadcrumb.label}
                                    </Link>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </div>
        </nav>
    );
};

export default Breadcrumb;